import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { BUSINESS_INSIGHT_SUBSECTIONS, type BusinessInsightSubsection, CardError, CardSkeleton, CardTitle, OnboardingBusinessInsight, useOnboardingBusinessInsights } from '@/components/entity-onboarding-details';
import useEntityId from '@/entities/components/details/hooks/use-entity-id';
type BusinessInsightsProps = {
  onboarding: EntityOnboarding;
};

/** Expects the onboarding's vault to be decrypted. */
const BusinessInsights = t0 => {
  const $ = _c(24);
  const {
    onboarding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const entityId = useEntityId();
  const {
    data,
    error
  } = useOnboardingBusinessInsights(entityId, onboarding.id);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp4);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp5);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = {
      "business-details": t2,
      people: t3,
      registrations: t4,
      watchlist: t5,
      offices: t6
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const titles = t7;
  if (!data) {
    let t8;
    if ($[17] !== error) {
      t8 = <div className="p-5">{error ? <CardError error={error} /> : <CardSkeleton cards={BUSINESS_INSIGHT_SUBSECTIONS.length} rows={3} />}</div>;
      $[17] = error;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  let t8;
  if ($[19] !== onboarding || $[20] !== titles) {
    t8 = BUSINESS_INSIGHT_SUBSECTIONS.map(key => <Card.Root key={key}><CardTitle title={titles[key]} /><OnboardingBusinessInsight selectedSubsection={key} onboarding={onboarding} /></Card.Root>);
    $[19] = onboarding;
    $[20] = titles;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t8) {
    t9 = <div className="flex flex-col gap-3 p-5" data-dd-privacy="mask">{t8}</div>;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default BusinessInsights;
function _temp($) {
  return $.businessDetails.title;
}
function _temp2($_0) {
  return $_0.people.title;
}
function _temp3($_1) {
  return $_1.registrations.title;
}
function _temp4($_2) {
  return $_2.watchlist.title;
}
function _temp5($_3) {
  return $_3.offices.title;
}